const currencyFormat = (amount, currency) => amount.toLocaleString(navigator.language, { style: 'currency', currency });

export default currencyFormat;



// WEBPACK FOOTER //
// ./src/utils/currency.js